const Icon = (props: any) => {
    return (
        <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.314 0h9.372C17.962 0 20 2.312 20 5.585v8.83C20 17.688 17.962 20 14.686 20H5.314C2.038 20 0 17.688 0 14.415v-8.83C0 2.312 2.048 0 5.314 0zm10.264 8.478a.75.75 0 00-1.156-.956l-2.686 3.243L8.65 8.497a.75.75 0 00-1.023.128L4.42 12.524a.75.75 0 101.158.952l2.755-3.35 3.085 2.267a.75.75 0 001.021-.126l3.138-3.789z"
                fill="currentColor"
            />
        </svg>
    );
};

export default Icon;
